<section class="login-page">
  <div class='right-side'>
    <form [formGroup]="resetPasswordForm" (ngSubmit)="submit()" class='mat-elevation-z3'>
      <h1>Reset Password</h1>
      <!-- <p class='error' *ngIf='authenticatingError$ | async'>{{authenticatingError$ | async}}</p> -->
      <formly-form [model]="model" [fields]="fields" [options]="options" [form]="resetPasswordForm"></formly-form>
      <div class='other-links'>
        <button mat-button color="warn" (click)="cancelPasswordReset()">Cancel</button>
        <button mat-raised-button color="primary" [disabled]="resetPasswordForm.invalid">Reset Password</button>
      </div>
      <a href="auth/sign-up">Don't have an account yet? Create an Account!</a>
    </form>
  </div>
</section>
